/*
 * IApteka CMS - v 3.0 - 2023
 *
 * @license MIT License
 * Original author: Vitaliy Kolobanov <vitaliy.kolobanov@gmail.com>
 */

// Format a number with grouped thousands
function number_format( number, decimals, dec_point, thousands_sep ) {
  //
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +     bugfix by: Michael White (http://crestidg.com)

  var i, j, kw, kd, km;

  // input sanitation & defaults
  if( isNaN(decimals = Math.abs(decimals)) ){
    decimals = 2;
  }
  if( dec_point == undefined ){
    dec_point = ",";
  }
  if( thousands_sep == undefined ){
    thousands_sep = ".";
  }

  i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

  if( (j = i.length) > 3 ){
    j = j % 3;
  } else{
    j = 0;
  }

  km = (j ? i.substr(0, j) + thousands_sep : "");
  kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
  //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
  kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");


  return km + kw + kd;
}

function setMobileVersion() {
  $.cookie('is_mobile', '1', {
    path: '/;SameSite=Lax',
    secure: false
  });
  location.reload();
  return false;
}

function langSwitch(lang, href) {
  if (lang && href) {
    $.cookie('site_lng', lang, {
      expires: 365, // 1 year cookie
      path: '/;SameSite=Lax',
      secure: false
    });

    location.href = href;
  }

  return false;
}

function sendToBin(id, formName) {
  formName = typeof formName !== "undefined" ? formName : 'buy_form';
  $('form[name="' + formName + '_' + id + '"]').submit();
  return false;
}

function summa(id, price) {
  var kol = $('#buy_count_' + id).val();
  var s = Math.round(kol * price * 100) / 100;
  $('#summa_' + id).html(number_format(s, 2, ',', ' '));
}

function updateBin(itemId, itemPrice, itemCount) {
  if(itemId != undefined) {
    var s = Math.round(itemCount * itemPrice * 100) / 100;
    var $summa = $('#summa_' + itemId);

    $summa.html(number_format(s, 2, ',', ' '));

    if(itemCount <= 0) {
      $summa.closest('tr').remove(); // remove table row
    }

    $.ajax({
      type : "POST",
      url : "ajax.func.update_bin.php",
      data : {'addbin' : itemId, 'buy_count' : itemCount},
      async : true,
      success : function(data) {
        eval(data);
      },
      error : function(xhr, ajaxOptions, thrownError) {
        console.log("updateBin() Error! " + thrownError);
      }
    });
  }
}

function deleteFromBin(itemId) {
  if(itemId != undefined) {
    $('#summa_' + itemId).closest('tr').remove(); // remove table row

    $.ajax({
      type : "POST",
      url : "ajax.func.update_bin.php",
      data : {'addbin' : itemId, 'buy_count' : 0},
      async : true,
      success : function(data) {
        eval(data);
      },
      error : function(xhr, ajaxOptions, thrownError) {
        console.log("deleteFromBin() Error! " + thrownError);
      }
    });
  }
}

function clearBin() {
  $.ajax({
    type : "POST",
    url : "ajax.func.clear_bin.php",
    data : {'empty_bin' : '1'},
    dataType : "json",
    async : true,
    success : function(json) {
      if(json.clear_bin == true) {
        location.reload();
      }
    },
    error : function(xhr, ajaxOptions, thrownError) {
      console.log("clearBin() Error! " + thrownError);
    }
  });

  return false;
}

function artVote(value, artId) {
  if(value != undefined && artId != undefined) {
    $.ajax({
      type : "POST",
      url : "ajax.func.article_vote.php",
      data : {'vote' : value, 'art_id' : artId},
      async : true,
      success : function(data) {
        eval(data);
      },
      error : function(xhr, ajaxOptions, thrownError) {
        console.log("voteArt() Error! " + thrownError);
      }
    });
  }

  return false;
}

function artComment(comment, artId) {
  if(comment != undefined && artId != undefined) {
    $.ajax({
      type : "POST",
      url : "ajax.func.article_comment.php",
      data : {'comment' : comment, 'art_id' : artId},
      async : true,
      success : function(data) {
        eval(data);
      },
      error : function(xhr, ajaxOptions, thrownError) {
        console.log("artComment() Error! " + thrownError);
      }
    });
  }

  return false;
}

